<template>
    <div class="container">
        <p>Roll Formula</p>
        <ul id="log">
            <li v-bind:key="roll.id" v-for="roll in textOutput">
                {{ roll }}
            </li>
        </ul>
    </div>
</template>

<script>
export default {
    computed: {
        rollLog() {
            return this.$store.getters['gamestate/rollLog'];
        },
        textOutput() {
            let output = [];
            for (const diceResult of this.rollLog) {
                output.push(diceResult.userId + ' rolled ' + diceResult.result);
            }
            return output;
        },
    },
};
</script>

<style scoped>
.container {
    height: 20vh;
    overflow-y: auto;
    bottom: 5px;
    right: 5px;
    padding: 0.5em;
    background-color: #ddd;
    font: x-small Consolas, Monaco, monospace;
    color: black;
    border: 2px solid #345;
}
</style>
